import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Articles from "@/pages/Articles";
import Photojournalism from "@/pages/Photojournalism";
import Events from "@/pages/Events";
import CorrespondentProfile from "@/pages/CorrespondentProfile";
import Contact from "@/pages/Contact";
import PhotoOfTheMonth from "@/pages/PhotoOfTheMonth";
import About from "@/pages/About";
import ArticlePage from "@/pages/ArticlePage";
import Partner from "@/pages/Partner";
import Sponsors from "@/pages/Sponsors";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center font-sans text-ink/60">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/articles" element={<PublicLayout><Articles /></PublicLayout>} />
              <Route path="/photojournalism" element={<PublicLayout><Photojournalism /></PublicLayout>} />
              <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
              <Route path="/correspondent/:id" element={<PublicLayout><CorrespondentProfile /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/photo-of-the-month" element={<PublicLayout><PhotoOfTheMonth /></PublicLayout>} />
              <Route path="/photo-of-the-month/:id" element={<PublicLayout><PhotoOfTheMonth /></PublicLayout>} />
              <Route path="/partner" element={<PublicLayout><Partner /></PublicLayout>} />
              <Route path="/sponsors" element={<PublicLayout><Sponsors /></PublicLayout>} />
              <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/article/:id" element={<PublicLayout><ArticlePage /></PublicLayout>} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
